import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';

import { IglesiasService } from '../services/iglesias.service';
import { UserStore } from '../services/user-store.service';

export const liderGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isLider()) {
    return true;
  }

  return router.createUrlTree(['/configuracion', 'mi-cuenta']);
};

/** Tomar lista también lo usa el administrador cuando la iglesia lo habilita. */
export const tomarListaGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);

  if (userStore.isLider() || userStore.isAdmin()) {
    return true;
  }

  return router.createUrlTree(['/configuracion', 'mi-cuenta']);
};

/** La línea de tiempo la ven líderes y administradores, si la iglesia tiene eventos encendidos. */
export const eventosGuard: CanActivateFn = () => {
  const userStore = inject(UserStore);
  const router = inject(Router);
  const iglesias = inject(IglesiasService);

  if (!userStore.isLider() && !userStore.isAdmin()) {
    return router.createUrlTree(['/configuracion', 'mi-cuenta']);
  }

  const destino = userStore.isAdmin()
    ? router.createUrlTree(['/congregacion'])
    : router.createUrlTree(['/lider']);

  return iglesias.getCurrentIglesia().pipe(
    map((iglesia) => (iglesia.eventos !== false ? true : destino)),
    catchError(() => of(true)),
  );
};

/** Configuración de eventos: solo entra si la sección está encendida. */
export const iglesiaEventosGuard: CanActivateFn = () => {
  const router = inject(Router);
  const iglesias = inject(IglesiasService);

  return iglesias.getCurrentIglesia().pipe(
    map((iglesia) =>
      iglesia.eventos !== false
        ? true
        : router.createUrlTree(['/configuracion', 'iglesia-funcionamiento']),
    ),
    catchError(() => of(true)),
  );
};
